/*
  BestPower — глобално подреждане на категорийния грид.

  Liquid вижда само текущата страница, затова редът
  "наши марки → други → изчерпани" не може да се направи сървърно
  за цялата колекция. Тук дърпаме всички страници на секцията през
  Section Rendering API, подреждаме целия набор и показваме парчето
  за текущата страница.

  Пагинацията става клиентска — при клик на "2" гридът се сменя
  моментално от вече заредените данни, без презареждане и без
  проблясък на стария ред.

  Активира се само при "чист" изглед — без сортиране и без филтри.
  Флагът идва от data-bp-global на #product-grid.
  При всяка грешка не пипаме нищо и остава сървърният ред.
*/
(function () {
  var grid = document.getElementById('product-grid');
  if (!grid || grid.getAttribute('data-bp-global') !== 'true') return;
  if (typeof window.fetch !== 'function' || typeof window.Promise !== 'function') return;

  var pages = parseInt(grid.getAttribute('data-bp-pages'), 10) || 1;
  var page = parseInt(grid.getAttribute('data-bp-page'), 10) || 1;
  var perPage = parseInt(grid.getAttribute('data-bp-per-page'), 10) || 16;
  var sectionId = grid.getAttribute('data-bp-section');
  var base = grid.getAttribute('data-bp-url');
  var priority = (grid.getAttribute('data-bp-priority') || '').split('|').filter(Boolean);

  if (pages < 2 || !sectionId || !base) return;

  /* Скриваме грида веднага, за да не се види сървърният ред.
     Ако нещо се забави или счупи, показваме го пак след 3 сек. */
  var style = document.createElement('style');
  style.textContent = '#product-grid[data-bp-pending]{opacity:0}';
  document.head.appendChild(style);
  grid.setAttribute('data-bp-pending', '');
  var reveal = function () { grid.removeAttribute('data-bp-pending'); };
  var failSafe = setTimeout(reveal, 3000);

  var docs = [];
  var sorted = null;

  function rankOf(el) {
    var vendor = el.getAttribute('data-bp-vendor') || '';
    var avail = el.getAttribute('data-bp-avail') === '1';
    var idx = priority.indexOf(vendor);
    if (avail && idx > -1) return { group: 0, vendor: idx };
    if (avail) return { group: 1, vendor: 999 };
    if (idx > -1) return { group: 2, vendor: idx };
    return { group: 3, vendor: 999 };
  }

  function rotate(list) {
    var buckets = {};
    var keys = [];
    list.forEach(function (o) {
      if (!buckets[o.v]) {
        buckets[o.v] = [];
        keys.push(o.v);
      }
      buckets[o.v].push(o);
    });
    keys.sort(function (a, b) { return a - b; });
    var out = [];
    var moved = true;
    while (moved) {
      moved = false;
      keys.forEach(function (k) {
        if (buckets[k].length) {
          out.push(buckets[k].shift());
          moved = true;
        }
      });
    }
    return out;
  }

  function orderItems(items) {
    var g = [[], [], [], []];
    items.forEach(function (el, i) {
      var r = rankOf(el);
      g[r.group].push({ el: el, v: r.vendor, i: i });
    });
    g[0] = rotate(g[0]);
    g[2] = rotate(g[2]);
    return g[0].concat(g[1], g[2], g[3]).map(function (o) { return o.el; });
  }

  function bindPagination() {
    var wrap = document.querySelector('.pagination-wrapper');
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a') : null;
      if (!link || !link.href || link.href.indexOf('page=') === -1) return;
      var m = link.href.match(/[?&]page=(\d+)/);
      if (!m) return;
      e.preventDefault();
      render(parseInt(m[1], 10), true);
    });
  }

  function render(n, push) {
    if (!sorted || n < 1 || n > pages) return;
    var slice = sorted.slice((n - 1) * perPage, n * perPage);
    if (!slice.length) return;

    grid.innerHTML = '';
    slice.forEach(function (li, i) {
      var node = li.cloneNode(true);
      node.style.setProperty('--animation-order', i + 1);
      grid.appendChild(node);
    });

    var oldWrap = document.querySelector('.pagination-wrapper');
    var newWrap = docs[n - 1] ? docs[n - 1].querySelector('.pagination-wrapper') : null;
    if (oldWrap && newWrap) {
      oldWrap.parentNode.replaceChild(newWrap.cloneNode(true), oldWrap);
      bindPagination();
    }

    page = n;
    if (push) {
      var url = base + (n > 1 ? '?page=' + n : '');
      history.pushState({ bpPage: n }, '', url);
      var top = document.getElementById('ProductGridContainer');
      if (top) window.scrollTo({ top: top.offsetTop - 80, behavior: 'smooth' });
    }
    grid.setAttribute('data-bp-sorted', 'true');
    document.dispatchEvent(new CustomEvent('bp:grid-sorted'));
  }

  var reqs = [];
  for (var p = 1; p <= pages; p++) {
    reqs.push(
      fetch(base + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + p, {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; })
    );
  }

  Promise.all(reqs)
    .then(function (htmls) {
      var parser = new DOMParser();
      var all = [];
      for (var i = 0; i < htmls.length; i++) {
        if (!htmls[i]) throw new Error('empty page');
        var doc = parser.parseFromString(htmls[i], 'text/html');
        var g = doc.getElementById('product-grid');
        if (!g) throw new Error('no grid');
        docs.push(doc);
        /* Картата рендира своя <style> само в първата карта на страницата.
           При разбъркване тази карта може да не е на текущата страница,
           затова вдигаме стиловете в <head> веднъж. */
        if (!document.getElementById('bp-card-styles')) {
          var st = g.querySelector('style');
          if (st) {
            var clone = document.createElement('style');
            clone.id = 'bp-card-styles';
            clone.textContent = st.textContent;
            document.head.appendChild(clone);
          }
        }
        Array.prototype.forEach.call(g.children, function (li) { all.push(li); });
      }
      if (!all.length) throw new Error('no items');

      sorted = orderItems(all);
      render(page, false);
      bindPagination();

      window.addEventListener('popstate', function () {
        var m = window.location.search.match(/[?&]page=(\d+)/);
        render(m ? parseInt(m[1], 10) : 1, false);
      });
    })
    .catch(function () {})
    .then(function () {
      clearTimeout(failSafe);
      reveal();
    });
})();
